// import { createClient } from "next-sanity";
import { createClient } from "@sanity/client";

export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID;
export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;
export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION;

// export default createClient({
//   projectId, // you can find this in sanity.json
//   dataset, // or the name you chose in step 1
//   useCdn: true, // `false` if you want to ensure fresh data
// });

export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: true,
});
